export const dollarsToCents = function(dollars) {
    dollars = parseFloat(dollars)
    if (isNaN(dollars)) return null
    return Math.round(dollars * 100)
}

export const centsToDollars = function(cents) {
    cents = parseInt(cents)
    if (isNaN(cents)) return null
    return cents / 100.0
}

const wholeDollarsFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})

const dollarsCentsFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
})

export const formatCurrency = function(value, fromUnit = "cents", includeCents = true) {
    if (value == null) {
        return null
    }

    if (typeof value === "string") {
        value = parseFloat(value)
    }

    if (fromUnit === "cents") {
        value = value / 100
    }

    let formatter

    if (includeCents) {
        formatter = dollarsCentsFormatter
    } else {
        formatter = wholeDollarsFormatter
    }

    return formatter.format(value)
}

export const formatWholeCurrency = function(value, fromUnit = "cents") {
    return formatCurrency(value, fromUnit, false)
}

export default {
    centsToDollars,
    dollarsToCents,
    formatCurrency,
}
